module.exports = __webpack_public_path__ + "static/media/ta-04.14e752fb.png";